<template>
  <div class="common-timer">
    <div v-if="isInit" :class="type">
      <b class="day" v-if="times.d !== '00'">{{ times.d }}</b>
      <b>{{ times.h }}</b>
      <b>{{ times.m }}</b>
      <b>{{ times.s }}</b>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { timerCount } from '@/utils/tools';
import { reqServiceTime } from '@/api/common';

export default {
  props: {
    type: {
      type: String,
      default: 'default',
    },
    endTime: {
      type: [Number, String, Object],
      default: 0,
    },
  },
  data() {
    return {
      timers: null,
      times: null,
      isInit: false,
    };
  },
  mounted() {
    this.isInit = false;
    this.init();
  },
  methods: {
    async init() {
      const res = await reqServiceTime();
      if (res.code === 0) {
        const serviceTime = res.data;
        let temp = moment.unix(this.endTime).diff(moment(serviceTime), 'X');
        // let temp = 10000;
        if (temp >= 0) {
          this.times = timerCount(temp, 2);
        } else {
          this.times = {
            d: '00',
            h: '00',
            m: '00',
            s: '00',
          };
        }

        this.timers = setInterval(() => {
          temp -= 1000;
          if (temp >= 0) {
            this.times = timerCount(temp, 2);
          } else {
            // 倒计时结束  重新拉取接口请求
            clearInterval(this.timers);
            this.$emit('timerEnd');
          }
        }, 1000);
        this.isInit = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.common-timer {
  .default{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    b {
      position: relative;
      display: inline-block;
      min-width: 32px;
      height: 32px;
      margin-left: 26px;
      font-weight: bold;
      font-size: 22px;
      line-height: 32px;
      text-align: center;
      color: #FF1A3F;
      background: #fff;
      border-radius: 7px;

      &::after {
        position: absolute;
        top: 15px;
        right: -15px;
        display: inline-block;
        color: #fff;
        font-weight: 500;
        font-size: 22px;
        transform: translateY(-50%);
        content: ':';
      }
    }

    b.day {
      margin-right: 8px;
      margin-left: 0;

      &::after {
        top: 15px;
        right: -28px;
        font-size: 22px;
        content: '天';
      }
    }

    b:first-child {
      margin-left: 0;
    }

    b:last-child {
      &::after {
        display: none;
      }
    }
  }
  .groupBuy {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    b {
      position: relative;
      display: inline-block;
      min-width: 32px;
      height: 32px;
      margin-left: 5px;
      font-weight: bold;
      font-size: 22px;
      line-height: 32px;
      text-align: center;

      &::after {
        position: absolute;
        top: 15px;
        right: -5px;
        display: inline-block;
        color: #ff6c02;
        font-weight: 500;
        font-size: 22px;
        transform: translateY(-50%);
        content: ':';
      }
    }

    b.day {
      margin-right: 18px;
      margin-left: 0;

      &::after {
        top: 15px;
        right: -24px;
        font-size: 22px;
        content: '天';
      }
    }

    b:last-child {
      &::after {
        display: none;
      }
    }
  }
}
</style>
